
export const adminLogout = ()=>{
  sessionStorage.clear()
  window.location.assign("/login")
}